import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Container, Image, Button } from "react-bootstrap";
import { Document } from "react-pdf";
import { Page } from "react-pdf";
import NumberFormat from "react-number-format";
import errorStrings from "../../../../../errorMessages";
import { setDateTimeFormat } from "../../../../../utils/index";
import CustomButton from "../../../../../components/UI/Button/Button";
import * as actions from "../../../../../store/actions/index.js";
import Spinner from "../../../../../components/UI/Spinner/Spinner";
import NetworkAlert from "../../../../../components/UI/NetworkAlert/NetworkAlert";
import Modal from "../../../../../components/UI/Modal/Modal";
import DiscardBilling from "../../../DiscardBilling/DiscardBilling";
import UploadSuccessful from "../../../UploadSuccessful/UploadSuccessful";
import ProviderBillsBrowseImages from "../../../UploadBills/BrowseImages/BrowseImages";
import PatientsResonsibilityBrowseImages from "../../../PatientsResponsibility/BrowsePatientsResponsibility/BrowsePatientsResponsibility";
import ExplanationOfBenefitsBrowseImages from "../../../ExplanationOfBenefits/BrowseExplanationOfBenefits/BrowseExplanationOfBenefits";
import CollectionNoticeBrowseImages from "./CollectionNoticeBills/BrowseCollectionNoticeBills/BrowseCollectionNoticeBills";
import SubsequentProviderBillsBrowseImages from "./SubsequentProviderBills/BrowseSubsequentProviderBills/BrowseSubsequentProviderBills";
import ViewPatientsResponsibility from "../../../PatientsResponsibility/ViewPatientsResponsibility/ViewPatientsResponsibility";
import ViewExplanationOfBenefits from "../../../ExplanationOfBenefits/ViewExplanationOfBenefits/ViewExplanationOfBenefits";
import ViewingBills from "../../../UploadBills/ViewingBills/ViewingBills";
import ViewSubsequentProviderBills from "./SubsequentProviderBills/ViewSubsequentProviderBills/ViewSubsequentProviderBills";
import ViewCollectionNoticeBills from "./CollectionNoticeBills/ViewCollectionNoticeBills/ViewCollectionNoticeBills";
import ViewDisputeAuthorization from "../../../DisputeAuthorization/ViewDisputeSuthorization/ViewDisputeAuthorization";
import { logFirebaseEvent,updateObject } from "../../../../../shared/utility";
import Contact from "../../../../../components/UI/Alerts/Contact/Contact";
import jsPDF from "jspdf";

import classes from "./MyBillSummary.module.css";

import dollar from "../../../../../assets/images/icon-dollar-small.svg";
import sign from "../../../../../assets/images/icon-doc-sign.svg";

import arrowLeft from "../../../../../assets/images/arrow-left.svg";
import MyBills from "../../MyBills";
interface IParentProps {
  claimId: number;
  onBackToListClick: () => void;
  onViewProgressClick: () => void;
}

interface IStateFromProps {
  loadingDocumentTypes: boolean;
  errorDocumentTypes: boolean;
  documentTypes: {
    id: string;
    type: string;
    editable: boolean;
    order: number;
  }[];
  providerBills: File[];
  patientsResponsibilityBills: File[];
  explanationOfBenefitsBills: File[];
  disputeAuthorizationForm: string;
  collectionNoticeBills: File[];
  subsequentProviderBills: File[];
  loadingSubmitBills: boolean;
  loadingUserInfo: boolean;
  submittedBills: boolean;
  errorSubmitBills: boolean;
  errorMessageSubmitBills: string;
  submittedBillsDetails: boolean;
  loadingSubmitClaim: boolean;
  submittedSubmitClaim: boolean;
  errorSubmitClaim: boolean;
  errorMessageSubmitClaim: string;
  loadingClaimDetails: boolean;
  bestContactInfo: { phone: string; email: string };
  claimDetails: {
    clientId: number;
    clientGroupId: number;
    memberId: string;
    claimId: number;
    dateOfService: string;
    facility: string;
    patientId: number;
    addedDate: string;
    updatedDate: string;
    status: string;
    totalChargeAmount: number;
    document: {
      id: string;
      type: string;
      editable: boolean;
      order: number;
    }[];

    procedureLabel: string;
  };
  userInfo: {
    TPA: string;
    memberId: string;
    groupId: number;
    patientName: string;
  };
  myBillView: string;
  t:any;
}
interface IDispatchFromProps {
  onFetchUserInfo: (patientId: number) => void;
  onSubmitBills: (formData: FormData) => void;

  onSubmitBalanceBillingClaim: (claimDetails: {
    procedureLabel: string;
    claimId: number;
    patientId: number;
    dateOfService: string;
    facility: string;
    totalChargeAmount: number;
    document: {
      id: string;
    }[];
  }) => void;
  onFetchBBClaimDetails: (claimId: number) => void;
  onRemoveCollectionNoticeBills: (fileArray: File[]) => void;
  onRemoveSubsequentProviderBills: (fileArray: File[]) => void;
  onRemoveExplanationOfBenefitsFiles: (fileArray: File[]) => void;
  onRemoveProviderBillsFiles: (fileArray: File[]) => void;
  onRemovePatientsResponsibilityFiles: (fileArray: File[]) => void;
  onResetDisputeAuthorizationFile: () => void;
  onResetSubmitBills: () => void;
  onResetSubmitBalanceBillingClaim: () => void;
  onResetSubmitContactInformation: () => void;
  onSetMyBillViewState: (myBillView) => void;
}
type Props = IParentProps &
  IStateFromProps &
  IDispatchFromProps &
  RouteComponentProps;

class MyBillSummary extends Component<Props> {
  state = {
    discardingBills: false,
    submittingBills: false,
    providerBillsUploading: false,
    patientsResponsibilityBillsUploading: false,
    explanationOfBenefitsBillsUploading: false,
    collectionNoticeBillsUploading: false,
    subsequentProviderBillsUploading: false,
    viewingProviderBills: false,
    viewingPatientsResponsibilityBills: false,
    viewingExplanationOfBenefitsBills: false,
    viewingDisputeAuthorizationForm: false,
    viewingCollectionNoticeBills: false,
    viewingSubsequentProviderBills: false,
    viewBillNumber: 0,
    bestContactInfo: {
      phone: this.props.bestContactInfo.phone,
      email: this.props.bestContactInfo.email,
    },
    errorPhone: "",
    errorEmail: "",
    formValid: false,
    documentTypesAdded: [],
    connect: false,
    providerBillsUploaded: false,
    patientsResponsibilityBillsUploaded: false,
    explanationOfBenefitsBillsUploaded: false,
    disputeAuthorizationFormUploaded: false,
    collectionNoticeBillsUploaded: false,
    subsequentProviderBillsUploaded: false,
    showMyBills: false,
  };
  componentDidMount() {
    logFirebaseEvent("MyBillsDetails")
    console.log("componentdidmount", this.props.claimId);
    this.props.onFetchBBClaimDetails(this.props.claimId);
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("this.props.submittedBills",this.props.submittedBills)
    console.log("prevprops.submittedBills",prevProps.submittedBills)
    console.log("this.props.myBillView",this.props.myBillView)
    console.log("prevProps.myBillView",prevProps.myBillView)
    if (
      JSON.stringify(this.props.claimDetails) !==
      JSON.stringify(prevProps.claimDetails)
    ) {
      console.log(
        "JSON.stringify(this.props.claimDetails)",
        JSON.stringify(this.props.claimDetails)
      );
      console.log(
        "JSON.stringify(prevProps.claimDetails)",
        JSON.stringify(prevProps.claimDetails)
      );
      if (this.props.claimDetails.patientId !== 0) {
        this.props.onFetchUserInfo(this.props.claimDetails.patientId);
      }
      this.checkDocAlreadyUploaded();
    }

    if (
      this.props.submittedBills !== prevProps.submittedBills &&
      this.props.submittedBills === true
    ) {
      const submitClaim = {
        procedureLabel: this.props.claimDetails.procedureLabel,
        claimId: this.props.submittedBillsDetails[0].claimId,
        patientId: this.props.claimDetails.patientId,
        dateOfService: this.props.claimDetails.dateOfService,
        facility: this.props.claimDetails.facility,
        totalChargeAmount: this.props.claimDetails.totalChargeAmount,
        document: this.state.documentTypesAdded,
      };
      console.log("submitClaim", submitClaim);
      this.props.onSubmitBalanceBillingClaim(submitClaim);
    }
    if (prevProps.myBillView !== this.props.myBillView) {
      console.log("inside if of getStarted");
      if (this.props.myBillView === "myBillList") {
        this.setState({ showMyBills: true });
      } else if (this.props.myBillView === "myBillsSummary") {
        this.setState({ showMyBills: false });
      }
    }
  }
  discardBillsHandler = () => {
    this.setState({ discardingBills: true });
  };
  donotDiscardBillsHandler = () => {
    this.setState({ discardingBills: false });
  };
  submitDoneHandler = (goToHome) => {
    this.setState({ submittingBills: false });
    this.setState({ documentTypesAdded: [] });
    this.props.onResetSubmitBills();
    this.props.onResetSubmitBalanceBillingClaim();
    this.props.onResetSubmitContactInformation();
    
    if (goToHome) {
    //   this.props.history.push("/");
    this.props.onSetMyBillViewState("myBillList");
    this.props.onRemoveProviderBillsFiles([]);
    this.props.onRemovePatientsResponsibilityFiles([]);
    this.props.onRemoveExplanationOfBenefitsFiles([]);
    this.props.onRemoveCollectionNoticeBills([]);
    this.props.onRemoveSubsequentProviderBills([]);
    }
  };
  contactAdvocacyHandler = () => {
    this.setState({ connect: true });
  };
  connectedHandler = () => {
    this.setState({ connect: false });
  };
  encodeFileBase64 = (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
        // reader.onload = () => {
        //   let result = reader.result as string;
        //   this.providerBillsBase64.push(result.split(",")[1]);
        //   console.log("providerBillsBase64", this.providerBillsBase64);
        //   // console.log("resultArray", resultArray);
        //   // console.log("resultArray after split",resultArray[0].split(',')[1]);
        // };
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = () => reject("Can't convert");
      }
    });
  };
  makePDF(image, resultArray) {
    console.log("image ", image);
    console.log("image resultArray ", resultArray);
    var doc = new jsPDF();
    doc.addImage(image, "JPEG", 0, 0, 210, 297);
    //doc.save("test.pdf");
    //doc.output("dataurlstring");
    //window.open(doc.output("dataurlstring") as any, "_blank");
    resultArray.push(doc.output("blob"));
  }
  submitHandler = async () => {
    logFirebaseEvent("BalanceBillSubmitButtonPressed");
    // console.log(this.props.newUploadData);
    const fd = new FormData();
    fd.append("claimId", this.props.claimDetails.claimId.toString());
    let fileNames: string[] = [];
    let documentIdsToAdd;
    let updateDocumentTypesAdded: { id: string }[] = [];
    let billsToPdf = [];
    // var downloadPdf = (blob, fileName) => {
    //   const link = document.createElement("a");
    //   link.href = URL.createObjectURL(blob);
    //   link.download = fileName;
    //   document.body.append(link);
    //   link.click();
    //   link.remove();
    //   setTimeout(() => URL.revokeObjectURL(link.href), 2000);
    // };
    /*provider billing statement*/
    if (this.props.providerBills.length > 0) {
      documentIdsToAdd = this.props.documentTypes.find(
        (documentType) => documentType.order === 1
      );
      billsToPdf = [];
      for (let i = 0; i < this.props.providerBills.length; i++) {
        console.log("providerBills ", i);
        if (!this.props.providerBills[i].name.includes("pdf")) {
          let bill: any = await this.encodeFileBase64(
            this.props.providerBills[i]
          );
          if (bill !== "Can't convert") {
            this.makePDF(bill, billsToPdf);
            console.log("billsToPdf", billsToPdf);
            //fd.append("files", billsToPdf[i], "application/pdf");
            // downloadPdf( arrayBufferToBlob(billsToPdf[i]), "bill.pdf");
            // fileNames.push(`${documentIdsToAdd.type}_${i}`);
            //fileNames.push(`${documentIdsToAdd.type}`);
          }
        } else {
          fd.append("files", this.props.providerBills[i]);
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      if (billsToPdf.length > 0) {
        for (let i = 0; i < billsToPdf.length; i++) {
          fd.append("files", billsToPdf[i], "application/pdf");
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      updateDocumentTypesAdded = [
        ...this.state.documentTypesAdded,
        { id: documentIdsToAdd.id },
      ];
    }
    /*proof of payment receipts*/
    if (this.props.patientsResponsibilityBills.length > 0) {
      documentIdsToAdd = this.props.documentTypes.find(
        (documentType) => documentType.order === 3
      );
      billsToPdf = [];
      for (let i = 0; i < this.props.patientsResponsibilityBills.length; i++) {
        console.log("patientsResponsibilityBills ", i);
        if (!this.props.patientsResponsibilityBills[i].name.includes("pdf")) {
          let bill: any = await this.encodeFileBase64(
            this.props.patientsResponsibilityBills[i]
          );
          if (bill !== "Can't convert") {
            this.makePDF(bill, billsToPdf);
            console.log("billsToPdf", billsToPdf);
            // fd.append("files", billsToPdf[i], "application/pdf");
            // fileNames.push(`${documentIdsToAdd.type}`);
          }
        } else {
          fd.append("files", this.props.patientsResponsibilityBills[i]);
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      if (billsToPdf.length > 0) {
        for (let i = 0; i < billsToPdf.length; i++) {
          fd.append("files", billsToPdf[i], "application/pdf");
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      updateDocumentTypesAdded = [
        ...updateDocumentTypesAdded,
        { id: documentIdsToAdd.id },
      ];
    }
    /*explanation of benefits*/
    if (this.props.explanationOfBenefitsBills.length > 0) {
      documentIdsToAdd = this.props.documentTypes.find(
        (documentType) => documentType.order === 4
      );
      billsToPdf = [];
      for (let i = 0; i < this.props.explanationOfBenefitsBills.length; i++) {
        console.log("patientsResponsibilityBills ", i);
        if (!this.props.explanationOfBenefitsBills[i].name.includes("pdf")) {
          let bill: any = await this.encodeFileBase64(
            this.props.explanationOfBenefitsBills[i]
          );
          if (bill !== "Can't convert") {
            this.makePDF(bill, billsToPdf);
            console.log("billsToPdf", billsToPdf);
            // fd.append("files", billsToPdf[i], "application/pdf");
            // fileNames.push(`${documentIdsToAdd.type}`);
          }
        } else {
          fd.append("files", this.props.explanationOfBenefitsBills[i]);
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      if (billsToPdf.length > 0) {
        for (let i = 0; i < billsToPdf.length; i++) {
          fd.append("files", billsToPdf[i], "application/pdf");
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      updateDocumentTypesAdded = [
        ...updateDocumentTypesAdded,
        { id: documentIdsToAdd.id },
      ];
    }
    /* Dispute Authorization form */
    if (this.props.disputeAuthorizationForm) {
      documentIdsToAdd = this.props.documentTypes.find(
        (documentType) => documentType.order === 2
      );
      console.log(this.props.disputeAuthorizationForm);
      // let disputeAuthorizationFormBlob = arrayBufferToBlob(
      //   this.props.disputeAuthorizationForm
      // );
      // console.log(disputeAuthorizationFormBlob);
      billsToPdf = [];
      let bill: any = await this.encodeFileBase64(
        this.props.disputeAuthorizationForm
      );
      if (bill !== "Can't convert") {
        this.makePDF(bill, billsToPdf);
        console.log("billsToPdf", billsToPdf);
        //fd.append("files", billsToPdf[0], "application/pdf");
        //fileNames.push(`${documentIdsToAdd.type}`);
      }
      if (billsToPdf.length > 0) {
        for (let i = 0; i < billsToPdf.length; i++) {
          fd.append("files", billsToPdf[i], "application/pdf");
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      // fd.append("files", this.props.disputeAuthorizationForm);
      // fileNames.push(`${documentIdsToAdd.type}`);

      updateDocumentTypesAdded = [
        ...updateDocumentTypesAdded,
        { id: documentIdsToAdd.id },
      ];
    }
    /* collectionNoticeBills */
    if (this.props.collectionNoticeBills.length > 0) {
      documentIdsToAdd = this.props.documentTypes.find(
        (documentType) => documentType.order === 6
      );
      billsToPdf = [];
      for (let i = 0; i < this.props.collectionNoticeBills.length; i++) {
        if (!this.props.collectionNoticeBills[i].name.includes("pdf")) {
          console.log(
            "collectionnotice inside if - ",
            this.props.collectionNoticeBills[i].name
          );
          let bill: any = await this.encodeFileBase64(
            this.props.collectionNoticeBills[i]
          );
          if (bill !== "Can't convert") {
            this.makePDF(bill, billsToPdf);
            console.log("billsToPdf", billsToPdf);
            // fd.append("files", billsToPdf[i], "application/pdf");
            // fileNames.push(`${documentIdsToAdd.type}`);
          }
        } else {
          console.log(
            "collectionnotice inside else - ",
            this.props.collectionNoticeBills[i].name
          );
          fd.append("files", this.props.collectionNoticeBills[i]);
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      if (billsToPdf.length > 0) {
        for (let i = 0; i < billsToPdf.length; i++) {
          fd.append("files", billsToPdf[i], "application/pdf");
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      updateDocumentTypesAdded = [
        ...this.state.documentTypesAdded,
        { id: documentIdsToAdd.id },
      ];
    }
    /* subsequentProviderBills */
    if (this.props.subsequentProviderBills.length > 0) {
      documentIdsToAdd = this.props.documentTypes.find(
        (documentType) => documentType.order === 5
      );
      billsToPdf = [];
      for (let i = 0; i < this.props.subsequentProviderBills.length; i++) {
        if (!this.props.subsequentProviderBills[i].name.includes("pdf")) {
          let bill: any = await this.encodeFileBase64(
            this.props.subsequentProviderBills[i]
          );
          if (bill !== "Can't convert") {
            this.makePDF(bill, billsToPdf);
            console.log("billsToPdf", billsToPdf);
            // fd.append("files", billsToPdf[i], "application/pdf");
            // fileNames.push(`${documentIdsToAdd.type}`);
          }
        } else {
          fd.append("files", this.props.subsequentProviderBills[i]);
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      if (billsToPdf.length > 0) {
        for (let i = 0; i < billsToPdf.length; i++) {
          fd.append("files", billsToPdf[i], "application/pdf");
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      updateDocumentTypesAdded = [
        ...this.state.documentTypesAdded,
        { id: documentIdsToAdd.id },
      ];
    }
    let jsonstr = JSON.stringify(fileNames);
    fd.append("fileNames", jsonstr);

    console.log(fd);
    // if (this.validateForm()) {
    this.props.onSubmitBills(fd);
    this.setState({ documentTypesAdded: updateDocumentTypesAdded });
    this.setState({ submittingBills: true });
    // }
  };

  confirmDiscardBillsHandler = () => {
    this.props.onResetDisputeAuthorizationFile();
    this.props.onRemoveExplanationOfBenefitsFiles([]);
    this.props.onRemoveProviderBillsFiles([]);
    this.props.onRemovePatientsResponsibilityFiles([]);
    this.props.onRemoveCollectionNoticeBills([]);
    this.props.onRemoveSubsequentProviderBills([]);
    this.setState({ discardingBills: false });
    this.props.history.push("/");
  };
  setUploadedDocState = (docOrder: number) => {
    switch (docOrder) {
      case 1:
        this.setState({ providerBillsUploaded: true });
        break;
      case 2:
        this.setState({ disputeAuthorizationFormUploaded: true });
        break;
      case 3:
        this.setState({ patientsResponsibilityBillsUploaded: true });
        break;
      case 4:
        this.setState({ explanationOfBenefitsBillsUploaded: true });
        break;
      case 5:
        this.setState({ subsequentProviderBillsUploaded: true });
        break;
      case 6:
        this.setState({ collectionNoticeBillsUploaded: true });
        break;
    }
  };
  checkDocAlreadyUploaded = () => {
    //  if (this.props.documentTypes) {
    //   const documentTypeToCheck = this.props.documentTypes.find(
    //     (documentType) => documentType.order === docOrder
    //   );
    //   console.log("documentTypeToCheck", documentTypeToCheck);
    //   if (documentTypeToCheck) {
    //     console.log(
    //       this.props.claimDetails.document.find(
    //         (document) => document.id === documentTypeToCheck.id
    //       )
    //     );
    //     let docMatched = this.props.claimDetails.document.find(
    //       (document) => document.id === documentTypeToCheck.id
    //     );
    // if (docMatched) {
    // this.setUploadedDocState(docOrder);
    // }
    // return docMatched;
    // } else return false;
    // }
    // return false;

    this.props.claimDetails.document.map((document) =>
      this.setUploadedDocState(document.order)
    );
  };
  handleChange = (e) => {
    this.setState({ formValid: false });
    const updateContactParam = {
      [e.target.name]: e.target.value,
    };
    const updateContactInfo = updateObject(
      this.state.bestContactInfo,
      updateContactParam
    );
    this.setState({
      bestContactInfo: updateContactInfo,
      errorPhone: "",
      errorEmail: "",
    });
  };
  validateForm = () => {
    let phone = this.state.bestContactInfo.phone;
    let email = this.state.bestContactInfo.email;
    let formIsValid = true;
    const {t} = this.props;

    let phonePattern = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/; // (123) 123-1234;

    if (!phonePattern.test(phone)) {
      formIsValid = false;
      this.setState({
        errorPhone: t('errorMsg.errorPhone'),
      });
    }
    let emailPattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    if (!emailPattern.test(String(email).toLowerCase())) {
      formIsValid = false;
      this.setState({
        errorEmail: t('errorMsg.errorEmail'),
      });
    }
    return formIsValid;
  };
  deleteProviderBillsHandler = (index: number) => {
    var array = [...this.props.providerBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemoveProviderBillsFiles(array);
    }
  };

  deletePatientsResponsibilityHandler = (index: number) => {
    var array = [...this.props.patientsResponsibilityBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemovePatientsResponsibilityFiles(array);
    }
  };

  deleteExplanationOfBenefitsHandler = (index: number) => {
    var array = [...this.props.explanationOfBenefitsBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemoveExplanationOfBenefitsFiles(array);
    }
  };

  deleteCollectionNoticeBillsHandler = (index: number) => {
    var array = [...this.props.collectionNoticeBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemoveCollectionNoticeBills(array);
    }
  };

  deleteSubsequentProviderBillsHandler = (index: number) => {
    var array = [...this.props.subsequentProviderBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemoveSubsequentProviderBills(array);
    }
  };
  uploadProviderBillsHandler = () => {
    this.setState({ providerBillsUploading: true });
  };
  uploadedProviderBillsHandler = () => {
    this.setState({ providerBillsUploading: false });
  };
  uploadPatientsResponsibilityBillsHandler = () => {
    this.setState({ patientsResponsibilityBillsUploading: true });
  };
  uploadedPatientsResponsibilityBillsHandler = () => {
    this.setState({ patientsResponsibilityBillsUploading: false });
  };
  uploadExplanationOfBenefitsBillsHandler = () => {
    this.setState({ explanationOfBenefitsBillsUploading: true });
  };
  uploadedExplanationOfBenefitsBillsHandler = () => {
    this.setState({ explanationOfBenefitsBillsUploading: false });
  };
  uploadCollectionNoticeBillsHandler = () => {
    this.setState({ collectionNoticeBillsUploading: true });
  };
  uploadedCollectionNoticeBillsHandler = () => {
    this.setState({ collectionNoticeBillsUploading: false });
  };
  uploadSubsequentProviderBillsHandler = () => {
    this.setState({ subsequentProviderBillsUploading: true });
  };
  uploadedSubsequentProviderBillsHandler = () => {
    this.setState({ subsequentProviderBillsUploading: false });
  };
  viewingProviderBillsHandler = (index: number) => {
    console.log(index);
    this.setState({ viewBillNumber: index });
    this.setState({ viewingProviderBills: true });
  };
  closeViewingProviderBillsHandler = () => {
    this.setState({ viewingProviderBills: false });
  };
  viewingPatientsResponsibilityBillsHandler = (index: number) => {
    console.log(index);
    this.setState({ viewBillNumber: index });
    this.setState({ viewingPatientsResponsibilityBills: true });
  };
  closeViewingPatientsResponsibilityBillsHandler = () => {
    this.setState({ viewingPatientsResponsibilityBills: false });
  };
  viewingExplanationOfBenefitsBillsHandler = (index: number) => {
    console.log(index);
    this.setState({ viewBillNumber: index });
    this.setState({ viewingExplanationOfBenefitsBills: true });
  };
  closeViewingExplanationOfBenefitsBillsHandler = () => {
    this.setState({ viewingExplanationOfBenefitsBills: false });
  };
  viewingCollectionNoticeBillsHandler = (index: number) => {
    console.log(index);
    this.setState({ viewBillNumber: index });
    this.setState({ viewingCollectionNoticeBills: true });
  };
  closeViewingCollectionNoticeBillsHandler = () => {
    this.setState({ viewingCollectionNoticeBills: false });
  };

  viewingSubsequentProviderBillsHandler = (index: number) => {
    console.log(index);
    this.setState({ viewBillNumber: index });
    this.setState({ viewingSubsequentProviderBills: true });
  };
  closeViewingSubsequentProviderBillsHandler = () => {
    this.setState({ viewingSubsequentProviderBills: false });
  };
  viewingDisputeAuthorizationHandler = () => {
    this.setState({ viewingDisputeAuthorizationForm: true });
  };
  closeViewingDisputeAuthorizationHandler = () => {
    this.setState({ viewingDisputeAuthorizationForm: false });
  };
  backToList = () => {
    this.props.onRemoveProviderBillsFiles([]);
    this.props.onRemovePatientsResponsibilityFiles([]);
    this.props.onRemoveExplanationOfBenefitsFiles([]);
    this.props.onRemoveCollectionNoticeBills([]);
    this.props.onRemoveSubsequentProviderBills([]);
    this.props.onBackToListClick();
  };
  render() {
    const {t} = this.props;
    const { onBackToListClick, onViewProgressClick, claimDetails } = {
      ...this.props,
    };
    const nextBtnStyle = {
      minWidth: "150px",
    };
    // const elementLabelStyle = {
    //   fontSize: "13px",
    //   fontWeight: "600",
    //   color: "#117093",
    //   marginBottom: "3px",
    // };
    const modalContact = {
      width: "360px",
      left: "calc(50% - 180px)",
    };
    const modalChildStyle = {};
    const modalDiscard = {
      width: "360px",
      left: "calc(50% - 180px)",
    };
    const modalViewBillStyle = {
      width: "700px",
      left: "calc(50% - 350px)",
      top: "15%",
      position: "absolute",
    };
    let contact: any;
    if (this.state.connect) {
      contact = (
        <Modal
          show={this.state.connect}
          childComp={
            <Contact
              modalClosed={this.connectedHandler}
              email={t('contact.info')}
              contactNumber="(800) 425-9373"
              contactText={t('contact.contactAdvocacy')}
              logEvent="ContactAdvocacyEmailButtonPressed"
            />
          }
          style={modalContact}
        ></Modal>
      );
    }
    let viewProviderBills: any;
    if (this.state.viewingProviderBills) {
      viewProviderBills = (
        <Modal
          show={this.state.viewingProviderBills}
          childComp={
            <ViewingBills
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingProviderBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let viewPatientsResponsibilityBills: any;
    if (this.state.viewingPatientsResponsibilityBills) {
      viewPatientsResponsibilityBills = (
        <Modal
          show={this.state.viewingPatientsResponsibilityBills}
          childComp={
            <ViewPatientsResponsibility
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingPatientsResponsibilityBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let viewExplanationOfBenefitsBills: any;
    if (this.state.viewingExplanationOfBenefitsBills) {
      viewExplanationOfBenefitsBills = (
        <Modal
          show={this.state.viewingExplanationOfBenefitsBills}
          childComp={
            <ViewExplanationOfBenefits
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingExplanationOfBenefitsBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let viewCollectionNoticeBills: any;
    if (this.state.viewingCollectionNoticeBills) {
      viewCollectionNoticeBills = (
        <Modal
          show={this.state.viewingCollectionNoticeBills}
          childComp={
            <ViewCollectionNoticeBills
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingCollectionNoticeBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let viewSubsequentProviderBills: any;
    if (this.state.viewingSubsequentProviderBills) {
      viewSubsequentProviderBills = (
        <Modal
          show={this.state.viewingSubsequentProviderBills}
          childComp={
            <ViewSubsequentProviderBills
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingSubsequentProviderBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }
    console.log(
      "viewingDisputeAuthorizationForm",
      this.state.viewingDisputeAuthorizationForm
    );
    let viewDisputeAuthorizationForm: any;
    if (this.state.viewingDisputeAuthorizationForm) {
      console.log(
        "viewingDisputeAuthorizationForm",
        this.state.viewingDisputeAuthorizationForm
      );
      viewDisputeAuthorizationForm = (
        <Modal
          show={this.state.viewingDisputeAuthorizationForm}
          childComp={
            <ViewDisputeAuthorization
              closeViewing={this.closeViewingDisputeAuthorizationHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let providerBillsUpload: any;
    if (this.state.providerBillsUploading) {
      providerBillsUpload = (
        <Modal
          show={this.state.providerBillsUploading}
          childComp={
            <ProviderBillsBrowseImages
              modalClosed={this.uploadedProviderBillsHandler}
            />
          }
          style={{}}
        />
      );
    }

    let patientsResponsibilityBillsUpload: any;
    if (this.state.patientsResponsibilityBillsUploading) {
      patientsResponsibilityBillsUpload = (
        <Modal
          show={this.state.patientsResponsibilityBillsUploading}
          childComp={
            <PatientsResonsibilityBrowseImages
              modalClosed={this.uploadedPatientsResponsibilityBillsHandler}
            />
          }
          style={{}}
        />
      );
    }

    let explanationOfBenefitsBillsUpload: any;
    if (this.state.explanationOfBenefitsBillsUploading) {
      explanationOfBenefitsBillsUpload = (
        <Modal
          show={this.state.explanationOfBenefitsBillsUploading}
          childComp={
            <ExplanationOfBenefitsBrowseImages
              
              modalClosed={this.uploadedExplanationOfBenefitsBillsHandler}
            />
          }
          style={{}}
        />
      );
    }
    let collectionNoticeBillsUpload: any;
    if (this.state.collectionNoticeBillsUploading) {
      collectionNoticeBillsUpload = (
        <Modal
          show={this.state.collectionNoticeBillsUploading}
          childComp={
            <CollectionNoticeBrowseImages
              t={t}
              modalClosed={this.uploadedCollectionNoticeBillsHandler}
            />
          }
          style={{}}
        />
      );
    }
    let subsequentProviderBillsUpload: any;
    if (this.state.subsequentProviderBillsUploading) {
      subsequentProviderBillsUpload = (
        <Modal
          show={this.state.subsequentProviderBillsUploading}
          childComp={
            <SubsequentProviderBillsBrowseImages
              t={t}
              modalClosed={this.uploadedSubsequentProviderBillsHandler}
            />
          }
          style={{}}
        />
      );
    }

    /*contact information is last API to hit, displaying response on it's success*/
    let submitBills: any;
    if (this.props.submittedSubmitClaim) {
      submitBills = (
        <Modal
          show={this.state.submittingBills}
          childComp={
            <UploadSuccessful
              modalClosed={() => this.submitDoneHandler(true)}
              heading={t('submitBill.heading')}
              subHeading={t('submitBill.subHeading')}
            />
          }
          style={modalChildStyle}
        />
      );
    }

    /* Error Modal */
    let errorDisplay: any;
    if (this.props.errorSubmitBills) {
      errorDisplay = (
        <Modal
          show={this.state.submittingBills}
          childComp={
            <NetworkAlert
              modalClosed={() => this.submitDoneHandler(false)}
              error={errorStrings(this.props.errorMessageSubmitBills)?t(errorStrings(this.props.errorMessageSubmitBills)):this.props.errorMessageSubmitBills}
            />
          }
          style={modalChildStyle}
        />
      );
    }
    let errorDisplaySubmitClaim: any;
    if (this.props.errorSubmitClaim) {
      errorDisplaySubmitClaim = (
        <Modal
          show={this.state.submittingBills}
          childComp={
            <NetworkAlert
              modalClosed={() => this.submitDoneHandler(false)}
              error={errorStrings(this.props.errorMessageSubmitClaim)?t(errorStrings(this.props.errorMessageSubmitClaim)):this.props.errorMessageSubmitClaim}
            />
          }
          style={modalChildStyle}
        />
      );
    }

    const discardBills = (
      <Modal
        show={this.state.discardingBills}
        childComp={
          <DiscardBilling
            cancelDiscard={this.donotDiscardBillsHandler}
            confirmDiscard={this.confirmDiscardBillsHandler}
          />
        }
        style={modalDiscard}
      />
    );

    let providerBillsPreview: any;
    if (this.props.providerBills && this.props.providerBills.length > 0) {
      providerBillsPreview = (
        <div className="uploadPreviews upload-preview">
          {this.props.providerBills.map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {console.log("url is ", url.name)}
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() => this.viewingProviderBillsHandler(index)}
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() => this.viewingProviderBillsHandler(index)}
                  />
                )}
              </div>
              <span
                className="closeBtn"
                onClick={() => this.deleteProviderBillsHandler(index)}
              >
                <span>x</span>
              </span>
            </div>
          ))}
        </div>
      );
    }

    let patientsResponsibilityPreview: any;
    if (
      this.props.patientsResponsibilityBills &&
      this.props.patientsResponsibilityBills.length > 0
    ) {
      patientsResponsibilityPreview = (
        <div className="uploadPreviews upload-preview">
          {this.props.patientsResponsibilityBills.map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {console.log("url is ", url.name)}
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() =>
                        this.viewingPatientsResponsibilityBillsHandler(index)
                      }
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() =>
                      this.viewingPatientsResponsibilityBillsHandler(index)
                    }
                  />
                )}
              </div>
              <span
                className="closeBtn"
                onClick={() => this.deletePatientsResponsibilityHandler(index)}
              >
                <span>x</span>
              </span>
            </div>
          ))}
        </div>
      );
    }

    let explanationOfBenefitsPreview: any;
    if (
      this.props.explanationOfBenefitsBills &&
      this.props.explanationOfBenefitsBills.length > 0
    ) {
      explanationOfBenefitsPreview = (
        <div className="uploadPreviews upload-preview">
          {this.props.explanationOfBenefitsBills.map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {console.log("url is ", url.name)}
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() =>
                        this.viewingExplanationOfBenefitsBillsHandler(index)
                      }
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() =>
                      this.viewingExplanationOfBenefitsBillsHandler(index)
                    }
                  />
                )}
              </div>
              <span
                className="closeBtn"
                onClick={() => this.deleteExplanationOfBenefitsHandler(index)}
              >
                <span>x</span>
              </span>
            </div>
          ))}
        </div>
      );
    }

    let collectionNoticePreview: any;
    if (
      this.props.collectionNoticeBills &&
      this.props.collectionNoticeBills.length > 0
    ) {
      collectionNoticePreview = (
        <div className="uploadPreviews upload-preview">
          {this.props.collectionNoticeBills.map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {console.log("url is ", url.name)}
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() =>
                        this.viewingCollectionNoticeBillsHandler(index)
                      }
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() =>
                      this.viewingCollectionNoticeBillsHandler(index)
                    }
                  />
                )}
              </div>
              <span
                className="closeBtn"
                onClick={() => this.deleteCollectionNoticeBillsHandler(index)}
              >
                <span>x</span>
              </span>
            </div>
          ))}
        </div>
      );
    }

    let subsequentProviderBillsPreview: any;
    if (
      this.props.subsequentProviderBills &&
      this.props.subsequentProviderBills.length > 0
    ) {
      subsequentProviderBillsPreview = (
        <div className="uploadPreviews upload-preview">
          {this.props.subsequentProviderBills.map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {console.log("url is ", url.name)}
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() =>
                        this.viewingSubsequentProviderBillsHandler(index)
                      }
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() =>
                      this.viewingSubsequentProviderBillsHandler(index)
                    }
                  />
                )}
              </div>
              <span
                className="closeBtn"
                onClick={() => this.deleteSubsequentProviderBillsHandler(index)}
              >
                <span>x</span>
              </span>
            </div>
          ))}
        </div>
      );
    }

    // let disputeAuthorizationPreview: any;
    // if (this.props.disputeAuthorizationForm) {
    //   disputeAuthorizationPreview = (
    //     <div className="uploadPreviews upload-preview">
    //       <div className="uploadPreview">
    //         <div className="previewThumb">
    //           {/* {console.log("url is ", this.props.disputeAuthorizationForm.name)} */}
    //           <img
    //             src={this.props.disputeAuthorizationForm}
    //             alt="..."
    //             onClick={this.viewingDisputeAuthorizationHandler}
    //           />
    //         </div>
    //       </div>
    //     </div>
    //   );
    // }
    let spinner: any;
    if (this.props.loadingSubmitBills || this.props.loadingSubmitClaim) {
      spinner = <Spinner />;
    }
    let userInfoSpinner: any;
    if (this.props.loadingUserInfo) {
      userInfoSpinner = <Spinner />;
    }
    /* Loading */
    let spinnerLoadingClaimDetails: any;
    if (this.props.loadingClaimDetails) {
      spinnerLoadingClaimDetails = <Spinner />;
    }

    let documentTypesSpinner: any;
    if (this.props.loadingDocumentTypes) {
      documentTypesSpinner = <Spinner />;
    }

    /* Subsequent Provider Bills */
    let subsequentProviderBillsSection: any;
    if (this.props.claimDetails.claimId !== 0) {
      if (this.state.subsequentProviderBillsUploaded) {
        subsequentProviderBillsSection = (
          <div className="selectedFiles selected-files">
            <div>
              <Image src={sign} alt="sign" data-test="sign" /> {t('balanceBilling.documentAdd')}
            </div>
          </div>
        );
      } else {
        subsequentProviderBillsSection = (
          <div>
            <div className="selectedFiles selected-files">
              <div>
                <span className="filesCount">
                  {this.props.subsequentProviderBills
                    ? this.props.subsequentProviderBills.length
                    : "0"}
                </span>{" "}
                {t('balanceBilling.fileUpload')}
              </div>
            </div>
            {subsequentProviderBillsPreview}

            <Button
              className="btn-lg-border"
              disabled={false}
              onClick={this.uploadSubsequentProviderBillsHandler}
            >
              <span>
                {this.props.subsequentProviderBills.length <= 0
                  ? `${t('uploadFile.uploadBtn')} ${
                      this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 5
                      )?.type
                    }`
                  : t('submitBill.addMore')}
              </span>
              <i>+</i>
            </Button>
          </div>
        );
      }
    }
    /* Proof of payment Section */
    let proofOfPaymentSection: any;
    if (this.props.claimDetails.claimId !== 0) {
      if (this.state.patientsResponsibilityBillsUploaded) {
        proofOfPaymentSection = (
          <div className="selectedFiles selected-files">
            <div>
              <Image src={sign} alt="sign" data-test="sign" /> {t('balanceBilling.documentAdd')}
            </div>
          </div>
        );
      } else {
        proofOfPaymentSection = (
          <div>
            <div className="selectedFiles selected-files">
              <div>
                <span className="filesCount">
                  {this.props.patientsResponsibilityBills
                    ? this.props.patientsResponsibilityBills.length
                    : "0"}
                </span>{" "}
                {t('balanceBilling.fileUpload')}
              </div>
            </div>

            {patientsResponsibilityPreview}
            <Button
              className="btn-lg-border"
              onClick={this.uploadPatientsResponsibilityBillsHandler}
              disabled={false}
            >
              <span>
                {this.props.patientsResponsibilityBills.length <= 0
                  ? `${t('uploadFile.uploadBtn')} ${
                      this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 3
                      )?.type
                    }`
                  : t('submitBill.addMore')}
              </span>
              <i>+</i>
            </Button>
          </div>
        );
      }
    }
    /*Explanation Of Benefits Section*/
    let explanationOfBenefitsSection: any;
    if (this.props.claimDetails.claimId !== 0) {
      if (this.state.explanationOfBenefitsBillsUploaded) {
        explanationOfBenefitsSection = (
          <div className="selectedFiles selected-files">
            <div>
              <Image src={sign} alt="sign" data-test="sign" /> {t('balanceBilling.documentAdd')}
            </div>
          </div>
        );
      } else {
        explanationOfBenefitsSection = (
          <div>
            <div className="selectedFiles selected-files">
              <div>
                <span className="filesCount">
                  {this.props.explanationOfBenefitsBills
                    ? this.props.explanationOfBenefitsBills.length
                    : "0"}
                </span>
                {t('balanceBilling.fileUpload')}
              </div>
            </div>

            {explanationOfBenefitsPreview}

            <Button
              className="btn-lg-border"
              onClick={this.uploadExplanationOfBenefitsBillsHandler}
              disabled={false}
            >
              <span>
                {this.props.explanationOfBenefitsBills.length <= 0
                  ? `${t('uploadFile.uploadBtn')} ${
                      this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 4
                      )?.type
                    }`
                  : "t('submitBill.addMore')"}
              </span>
              <i>+</i>
            </Button>
          </div>
        );
      }
    }
    /*Provider Billing Section*/
    let providerBillingSection: any;
    if (this.props.claimDetails.claimId !== 0) {
      if (this.state.providerBillsUploaded) {
        providerBillingSection = (
          <div className="selectedFiles selected-files">
            <div>
              <Image src={sign} alt="sign" data-test="sign" /> {t('balanceBilling.documentAdd')}
            </div>
          </div>
        );
      } else {
        providerBillingSection = (
          <div>
            <div className="selectedFiles selected-files">
              <div>
                <span className="filesCount">
                  {this.props.providerBills
                    ? this.props.providerBills.length
                    : "0"}
                </span>
                {t('balanceBilling.fileUpload')}
              </div>
            </div>
            {providerBillsPreview}

            <Button
              className="btn-lg-border"
              onClick={this.uploadProviderBillsHandler}
              disabled={false}
            >
              <span>
                {this.props.providerBills.length <= 0
                  ? `${t('uploadFile.uploadBtn')} ${
                      this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 1
                      )?.type
                    }`
                  : "t('submitBill.addMore')"}
              </span>
              <i>+</i>
            </Button>
          </div>
        );
      }
    }
    /*CollectionNoticeSection*/
    let collectionNoticeSection: any;
    if (this.props.claimDetails.claimId !== 0) {
      if (this.state.collectionNoticeBillsUploaded) {
        collectionNoticeSection = (
          <div className="selectedFiles selected-files">
            <Image src={sign} alt="sign" data-test="sign" /> {t('balanceBilling.documentAdd')}
          </div>
        );
      } else {
        collectionNoticeSection = (
          <div>
            <div className="selectedFiles selected-files">
              <div>
                <span className="filesCount">
                  {this.props.collectionNoticeBills
                    ? this.props.collectionNoticeBills.length
                    : "0"}
                </span>{" "}
                {t('balanceBilling.fileUpload')}
              </div>
            </div>
            {collectionNoticePreview}

            <Button
              className="btn-lg-border"
              disabled={false}
              onClick={this.uploadCollectionNoticeBillsHandler}
            >
              <span>
                {this.props.collectionNoticeBills.length <= 0
                  ? `${t('uploadFile.uploadBtn')} ${
                      this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 6
                      )?.type
                    }`
                  : "t('submitBill.addMore')"}
              </span>
              <i>+</i>
            </Button>
          </div>
        );
      }
    }
    const myBillsSummary =
      claimDetails.claimId !== 0 ? (
        <Container fluid>
          {submitBills}
          {errorDisplay}
          {errorDisplaySubmitClaim}
          {discardBills}
          {providerBillsUpload}
          {patientsResponsibilityBillsUpload}
          {explanationOfBenefitsBillsUpload}
          {collectionNoticeBillsUpload}
          {subsequentProviderBillsUpload}
          {spinner}
          {userInfoSpinner}
          {documentTypesSpinner}
          {viewProviderBills}
          {viewPatientsResponsibilityBills}
          {viewExplanationOfBenefitsBills}
          {viewDisputeAuthorizationForm}
          {viewCollectionNoticeBills}
          {viewSubsequentProviderBills}
          {contact}
          <div className="inner-banner">
            <div className="inner-banner-title">
              <h3>{t('balanceBilling.balanceBilling')}</h3>
              <Image
                src={dollar}
                alt="stock-image"
                className={classes.stockimage}
                data-test="stockIMG"
              />
            </div>
          </div>
          <div className="bills-back-list">
            <Button className="btnLink iconLeft" onClick={onBackToListClick}>
              <Image src={arrowLeft} alt="arrowLeft" />
              {t('balanceBilling.backToList')}
            </Button>

            <h6 className="bill-heading">{t('balanceBilling.subTitle')}</h6>
          </div>

          <div className="quick-details-section">
            <h4>
              {claimDetails.procedureLabel}
              <span>{this.props.userInfo.patientName}</span>
            </h4>
            <div className="row">
              <div className="col-md-7 col-sm-12">
                <div className="quick-details quick-details-l">
                  <ul>
                    <li>
                      <h5>{t('balanceBilling.client')}</h5>
                      <span>{this.props.userInfo.TPA}</span>
                    </li>
                    <li>
                      <h5>{t('balanceBilling.groupId')}</h5>
                      <span>{this.props.userInfo.groupId}</span>
                    </li>
                    <li>
                      <h5>{t('balanceBilling.memberId')}</h5>
                      <span>{this.props.userInfo.memberId}</span>
                    </li>
                    <li>
                      <h5>{t('balanceBilling.ampsId')}</h5>
                      <span>{t('balanceBilling.inProcess')}</span>
                    </li>
                    <li>
                      <h5>{t('balanceBilling.status')}</h5>
                      <span className="progressInline">
                        {claimDetails.status}
                      </span>
                    </li>
                    <li>
                      <h5>{t('balanceBilling.submissions')}</h5>
                      <span>
                        <strong>{t('balanceBilling.lastUpdated')}</strong>&nbsp;
                        {setDateTimeFormat(claimDetails.updatedDate)}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-5 col-sm-12">
                <div className="quick-details quick-details-r">
                  <ul>
                    <li>
                      <h5>{t('balanceBilling.facility')}</h5>
                      <span>
                        {claimDetails.facility}
                        {/* <Image
                            src={shield}
                            alt="shield"
                            className={classes.shieldIcon}
                          /> */}
                      </span>
                    </li>
                    <li>
                      <h5>{t('balanceBilling.dateOfService')}</h5>
                      <span>{claimDetails.dateOfService} </span>
                    </li>
                    <li>
                      <h5>{t('balanceBilling.charges')}</h5>
                      <NumberFormat
                        value={claimDetails.totalChargeAmount}
                        isNumericString={true}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </li>
                  </ul>
                  <Button className="btn-small" onClick={onViewProgressClick}>
                    {" "}
                    {t('balanceBilling.viewProgressBtn')}{" "}
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="submissions">
            <h5> {t('balanceBilling.submissionCheckList')}</h5>
            <div className="row">
              <div className="col-lg-4 col-md-12 col-sm-12 flexInfo">
                <div className="submission-box">
                  <h5>
                    {this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 1
                      )?.type}
                  </h5>
                  {providerBillingSection}
                </div>
              </div>

              <div className="col-lg-4 col-md-12 col-sm-12 flexInfo">
                <div className="submission-box">
                  <h5>
                    {this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 2
                      )?.type}
                  </h5>
                  <div className="selectedFiles selected-files">
                    <div>
                      {" "}
                      <Image src={sign} alt="sign" data-test="sign" />{t('balanceBilling.documentSigned')}
                    </div>
                  </div>
                  {/* {disputeAuthorizationPreview} */}
                </div>
              </div>

              <div className="col-lg-4 col-md-12 col-sm-12 flexInfo">
                <div className="submission-box submission-box-bdr">
                  <h5>
                    {this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 3
                      )?.type}
                  </h5>
                  {proofOfPaymentSection}
                </div>
              </div>
            </div>
          </div>
          <div className="submissions submissions-sec">
            <div className="row">
              <div className="col-lg-4 col-md-12 col-sm-12 flexInfo">
                <div className="submission-box">
                  <h5>
                    {this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 4
                      )?.type}
                  </h5>
                  {explanationOfBenefitsSection}
                </div>
              </div>
              <div className="col-lg-4 col-md-12 col-sm-12 flexInfo">
                <div className="submission-box">
                  <h5>
                    {this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 5
                      )?.type}
                  </h5>
                  {subsequentProviderBillsSection}
                </div>
              </div>

              <div className="col-lg-4 col-md-12 col-sm-12 flexInfo">
                <div className="submission-box submission-box-bdr">
                  <h5>
                    {this.props.documentTypes.length > 0 &&
                      this.props.documentTypes.find(
                        (title) => title.order === 6
                      )?.type}
                  </h5>
                  {collectionNoticeSection}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="contact-information">
              <h5>Best Contact Information</h5>
              <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <Input
                    label="Email"
                    supportLabel=""
                    placeholder="johndoe@gmail.com"
                    elementLabelStyle={elementLabelStyle}
                    elementInputStyle={{}}
                    name="email"
                    errorText={this.state.errorEmail}
                    value={this.state.bestContactInfo.email}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="form-group">
                    <FormLabel className="form-label">Phone</FormLabel>
                    <NumberFormat
                      format="(###) ###-####"
                      placeholder="Phone(###) ###-####"Explanation of Benefits
                      name="phone"
                      value={this.state.bestContactInfo.phone}
                      className="form-control"
                      onChange={(e) => this.handleChange(e)}
                    />
                    <span className="errorMsg">{this.state.errorPhone}</span>
                  </div>
                </div>
              </div>
            </div> */}
          <div className="mainContainer">
            <div className="flexButtons">
              {/* <CustomButton
                  label="Discard"
                  clicked={this.discardBillsHandler}
                  style={nextBtnStyle}
                  displayImg={false}
                  image=""
                  disabled={false}
                /> */}
              <CustomButton
                label={t('balanceBilling.submitBtn')}
                clicked={this.submitHandler}
                style={nextBtnStyle}
                displayImg={false}
                image=""
                disabled={
                  this.props.errorDocumentTypes ||
                  !this.props.documentTypes ||
                  (this.props.documentTypes &&
                    this.props.documentTypes.length <= 0) ||
                  (this.state.providerBillsUploaded &&
                    this.state.patientsResponsibilityBillsUploaded &&
                    this.state.explanationOfBenefitsBillsUploaded &&
                    this.state.disputeAuthorizationFormUploaded &&
                    this.state.subsequentProviderBillsUploaded &&
                    this.state.collectionNoticeBillsUploaded)
                }
              />
              <CustomButton
                label={t('balanceBilling.contactBtn')}
                clicked={this.contactAdvocacyHandler}
                style={nextBtnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
            </div>
          </div>
        </Container>
      ) : (
        <Container fluid>
          <div className="inner-banner">
            <div className="inner-banner-title">
              <h3>{t('balanceBilling.balanceBilling')}</h3>
              <Image
                src={dollar}
                alt="stock-image"
                className={classes.stockimage}
                data-test="stockIMG"
              />
            </div>
          </div>
          <div className="bills-back-list">
            <Button className="btnLink iconLeft" onClick={onBackToListClick}>
              <Image src={arrowLeft} alt="arrowLeft" />
              {t('balanceBilling.backToList')}
            </Button>

            <h6 className="bill-heading">{t('balanceBilling.subTitle')}</h6>
          </div>
          <div className="no-data">
            <div className="no-data-msg">{t('balanceBilling.claimDetails')}</div>
          </div>
        </Container>
      );
    let showMyBillsState: any;
    if (this.state.showMyBills) {
      
      showMyBillsState = <MyBills />;
    } else {
      showMyBillsState = (
        <Fragment>
          {spinnerLoadingClaimDetails}
          {myBillsSummary}
        </Fragment>
      );
    }
    return <Fragment>{showMyBillsState}</Fragment>;
  }
}
const mapStateToProps = (state: any) => ({
  providerBills: state.browseImages.providerBills,
  patientsResponsibilityBills: state.browseImages.patientsResponsibilityBills,
  explanationOfBenefitsBills: state.browseImages.explanationOfBenefitsBills,
  disputeAuthorizationForm: state.disputeAuthorization.disputeAuthorizationForm,
  collectionNoticeBills: state.browseImages.collectionNoticeBills,
  subsequentProviderBills: state.browseImages.subsequentProviderBills,
  newUploadData: state.bbNewUpload.newUploadData,
  bestContactInfo: state.bestContactInfo,
  loadingSubmitBills: state.submitBills.loading,
  loadingUserInfo: state.fetchUserInfo.loading,
  submittedBills: state.submitBills.submitted,
  errorSubmitBills: state.submitBills.error,
  errorMessageSubmitBills: state.submitBills.errorMessage,
  submittedBillsDetails: state.submitBills.submittedBillsDetails,
  userInfo: state.fetchUserInfo.userInfo,
  loadingSubmitClaim: state.submitBalanceBillingClaim.loading,
  submittedSubmitClaim: state.submitBalanceBillingClaim.submitted,
  errorSubmitClaim: state.submitBalanceBillingClaim.error,
  errorMessageSubmitClaim: state.submitBalanceBillingClaim.errorMessage,
  claimDetails: state.fetchBBClaimDetails.claimDetails,
  loadingClaimDetails: state.fetchBBClaimDetails.loading,
  loadingDocumentTypes: state.fetchDocumentTypes.loading,
  errorDocumentTypes: state.fetchDocumentTypes.error,
  documentTypes: state.fetchDocumentTypes.documentTypes,
  myBillView: state.setBalanceBillViewState.myBillView,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchUserInfo: (patientId) => dispatch(actions.fetchUserInfo(patientId)),

  onSubmitBills: (formData) => dispatch(actions.submitBills(formData)),
  onSubmitBalanceBillingClaim: (submitClaim) =>
    dispatch(actions.submitBalanceBillingClaim(submitClaim)),
  onFetchBBClaimDetails: (claimId) =>
    dispatch(actions.fetchBBClaimDetails(claimId)),
  onRemoveExplanationOfBenefitsFiles: (explanationOfBenefitsBills) =>
    dispatch(actions.explanationOfBenefitsBills(explanationOfBenefitsBills)),
  onRemoveProviderBillsFiles: (providerBills) =>
    dispatch(actions.providerBills(providerBills)),
  onRemovePatientsResponsibilityFiles: (patientsResponsibilityBills) =>
    dispatch(actions.patientsResponsibilityBills(patientsResponsibilityBills)),
  onResetDisputeAuthorizationFile: () =>
    dispatch(actions.resetDisputeAuthorizationFile()),
  onRemoveCollectionNoticeBills: (collectionNoticeBills) =>
    dispatch(actions.collectionNoticeBills(collectionNoticeBills)),
  onRemoveSubsequentProviderBills: (subsequentProviderBills) =>
    dispatch(actions.subsequentProviderBills(subsequentProviderBills)),
  onResetSubmitBills: () => dispatch(actions.resetSubmitBills()),
  onResetSubmitBalanceBillingClaim: () =>
    dispatch(actions.resetSubmitBalanceBillingClaim()),
  onResetSubmitContactInformation: () =>
    dispatch(actions.resetSubmitContactInformation()),
  onSetMyBillViewState: (myBillView) =>
    dispatch(actions.setMyBillViewState(myBillView)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MyBillSummary));
// export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MyBillSummary));
